/* eslint-disable */
import React, { useState } from "react";

const EditCeGroupsPopUp = (props) => {
    const [view, setView] = useState('add_delete_groups');
    const [groupsSelected, setGroupsSelected] = useState(props.ceGroups || []);
    const [currentGroup, setCurrentGroup] = useState(props.ceGroups[0] || '');
    const [newGroupName, setNewGroupName] = useState({ name: '', error: null })

    const handleGroupsSelected = (action, value) => {
        if (action === 'delete') {
            setGroupsSelected(prevState => {
                let newGroups = prevState.filter(g => g[1] !== value)
                return newGroups;
            })
        }
    }

    const handleGroupName = (value) => {
        let groupExists = props.ceGroups.find(g => g[1] == value)
        if (groupExists) {
            setNewGroupName(prevState => {
                return {
                    ...prevState, 
                    error: 'Group name already exists. Please choose a new name.'
                }
            })
        } else {
            setNewGroupName(prevState => {
                return {
                    name: value, 
                    error: null
                }
            })
        }
    }

    return (
        <div className='ce-groups-popup'>
            <div>
                <div style={{ 'marginBottom': '15px' }}>
                    <div className='ce-groups-title'>Add a New Group</div>
                    <form onSubmit={(e) => props.addCeGroups(e, newGroupName.name)}>
                        <input id='new-ce-group-name' type='text' 
                          value={newGroupName.name}
                          autoFocus
                          onChange={(e) => handleGroupName(e.target.value)}  
                            style={{
                                padding: '4px 8px',      // creates real click target
                                minHeight: '24px',       // optional, ensures proper height
                                boxSizing: 'border-box',
                                background: 'transparent',
                                border: 'none',
                                boxShadow: 'inset 0px -1px 0px #BFBFBF',
                            }} />
                        <button className='ce-group-btns' type='submit'>Create Group</button>
                    </form>
                </div>

                <div>
                    <div className='ce-groups-title'>All Groups</div>
                    <div>Deleting a Group will delete it from Clients that may have it.</div>
                    {props.ceGroups.map((g, i) => {
                        return (
                            <div key={`${g}-${i}`}>
                                <span>{g[1]}</span>
                                <button className='ce-group-btns' onClick={() => props.deleteCeGroups(g[0])}>X</button>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className='ce-groups-popup-buttons'>
                <button className='ce-group-btns' onClick={() => props.closeEditCeGroupsModal()}>Cancel</button>
            </div>
        </div>
    )
}

export default EditCeGroupsPopUp;

//* <button className='ce-group-btns' onClick={() => setView('add_delete_groups')}>Add / Delete Groups</button>  */}
// : <button onClick={() => setView('edit_clients')}>Edit Client Groups</button>}

// {navBarInfo.parent_subdomain === 'cainellsworth' &&(<button onClick={() => setEditCeGroupsModalIsOpen(true)}>
// <FontAwesomeIcon icon={faPencil} /> Edit Groups
// </button>)
// }
// {
    // view === 'edit_clients'
    // ? (
        //     <div>
        //         <div className='ce-groups-header'>
        //             <div className='ce-groups-title'>Edit Client Groups</div>
        //             <div>Select Groups for the Selected Clients</div>
        //             <div>Saving Changes will override a client's groups if they already have groups assigned.</div>
        //         </div>
        //         <div className='ce-groups-select'>
        //             <div>Groups</div>
        //             <select
        //                 defaultValue={currentGroup}
        //                 onChange={({ target: { value } }) => {
            //                     setCurrentGroup(value)
            //                 }}
            //             >
            //                 {props.ceGroups.map(group => <option key={`cegroup-${group[1]}`} value={group[0]}>{group[1]}</option>)}
            //             </select>
            //             <button onClick={() => handleGroupsSelected('add', currentGroup)}>Add Group</button>
            //         </div>
            //         <div className='ce-groups-selected-container'>
            //             {groupsSelected.map(g => {
                //                 return (
                    //                     <div key={`selected-${g}`}>
                    //                         <span>{g}</span>
                    //                         <button onClick={() => handleGroupsSelected('delete', g)}>X Remove</button>
                    //                     </div>
                    //                 )
                    //             })}
                    //         </div>
                    //         <button onClick={() => props.updateCompanyCeGroups(groupsSelected)}>Save Group Changes</button>
                    //     </div>
                    // )
                    // : (
                        // )
                    // }

                    // {/* <p>{newGroupName.error}</p> */}